var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"video-js__wrapper"},[(!_vm.loaded)?_c('v-progress-circular',{staticClass:"video-js__loader",attrs:{"indeterminate":"","color":"white"}}):_vm._e(),_c('video',{ref:"videoPlayer",staticClass:"video-js",attrs:{"playsinline":"","autoplay":"","muted":"","loop":""},domProps:{"muted":true}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }